// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"48f438b3","667":"339ecfd7","977":"538e9deb"}[chunkId] + ".chunk.js";
};